let staggerIn = document.querySelectorAll('.js-stagger-in');

staggerIn.forEach((elem) => {
    
    let staggerElem = elem.children;

    gsap.set(staggerElem, {
        opacity: 0
    })

    ScrollTrigger.batch(staggerElem, {
        onEnter: batch => gsap.fromTo(batch, 1, {
            opacity: 0,
            stagger: 0.1
        }, {
            opacity: 1,
            y: 0,
            stagger: 0.1,
            ease: "sine.out"
        }),
        start: "top 80%",
        once: true,
        markers: false
    });

});


let fadeIn = document.querySelectorAll('.js-fade-in');

fadeIn.forEach((elem) => {
    
    let fadeInAnim = gsap.timeline({paused: true})
		.fromTo(elem, 1, { opacity: 0 }, {opacity: 1, ease: "sine.out"})

    ScrollTrigger.create({
        trigger: elem,
        start: "top 66%",
        once: true,
        onEnter: ({progress, direction, isActive}) => fadeInAnim.play(),
        markers: false
    });

});


let aboutCollage = document.querySelectorAll('.about-collage__svg');

aboutCollage.forEach((elem) => {

    let aboutImgFromLeft = elem.querySelectorAll('.js-about_img--from-left');
    let aboutImgFromRight = elem.querySelectorAll('.js-about_img--from-right');
    let aboutImgFadeIn = elem.querySelectorAll('.js-about_img--fade');

    let randomXPercent = (min, max) => Math.random() * (max - min) + min;
    let randomYPercent = (min, max) => Math.random() * (max - min) + min;
    
    aboutImgFromLeft.forEach((leftElem) => {
        let endXPercent = randomXPercent(-5, 5);
        let endYPercent = randomYPercent(-5, 5);

        gsap.fromTo(leftElem, {
            // rotation: startRotation,
            // opacity: 0,
            xPercent: 0,
            yPercent: 0
        }, {
            // rotation: 0,
            // opacity: 1,
            xPercent: endXPercent,
            yPercent: endYPercent,
            ease: "none",
            scrollTrigger: {
                trigger: leftElem,
                start: "top 50%",
                end: "bottom 0%",
                scrub: 1,
                markers: false
            }
        });
    });

    aboutImgFromRight.forEach((rightElem) => {
        let endXPercent = randomXPercent(-5, 5);
        let endYPercent = randomYPercent(-5, 5);
        
        gsap.fromTo(rightElem, {
            // rotation: startRotation,
            // opacity: 0,
            xPercent: 0,
            yPercent: 0
        }, {
            // rotation: 0,
            // opacity: 1,
            xPercent: -endXPercent,
            yPercent: -endYPercent,
            ease: "none",
            scrollTrigger: {
                trigger: rightElem,
                start: "top 50%",
                end: "bottom 0%",
                scrub: 1,
                markers: false
            }
        });
    });

    aboutImgFadeIn.forEach((fadeInElem) => {
        gsap.fromTo(fadeInElem, {
            opacity: 0
        }, {
            opacity: 1,
            ease: "sine.out",
            scrollTrigger: {
                trigger: fadeInElem,
                start: "top 80%",
                end: "top 20%",
                scrub: 1,
                markers: false
            }
        });
    });

});